// extracted by mini-css-extract-plugin
export default {"filesSelector":"FileSelector_filesSelector__m-Brv"};